import * as actionTypes from './umoCarouselActionTypes';

export const nextSlide = () => ({
  type: actionTypes.UMO_CAROUSEL_NEXT,
});

export const previousSlide = () => ({
  type: actionTypes.UMO_CAROUSEL_PREV,
});

export const setMaxIndex = (maxIndex) => ({
  type: actionTypes.UMO_CAROUSEL_MAX_INDEX,
  maxIndex,
});

export const setIndex = (index) => ({
  type: actionTypes.UMO_CAROUSEL_SET_INDEX,
  index,
});
